import React from 'react'
import './Button.css'

const Button = ({ className, value, onClick, children }) => (
  <button
    className={['configurator-button', className].join(' ')}
    onClick={onClick}
    onTouchEnd={onClick}
    value={value}
  >
    {children}
  </button>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js